<div class="header">
  <h1>Categories</h1>
  <button mat-button type="button" (click)="openCategoryDialog()">New Category</button>
</div>

<ng-container *ngIf="categories$ | async as categories; else loadingOrError">
  <ng-container *ngIf="categories.length; else empty">
    <div class="card-container overflow-hidden">
      <div class="card overflow-hidden" *ngFor="let category of categories" [routerLink]="[nav_path.adminCategories, category.slug, 'edit']">
        <h2 class="">{{category.name}}</h2>
        <p class="">{{category.description}}</p>
      </div>
    </div>
  </ng-container>

  <ng-template #empty>
    <div class="card empty">
      <h2 class="">No categories yet!</h2>
      <p class="">Create the first category to get us started.</p>
      <div class="btn-container">
        <button type="button" mat-button (click)="openCategoryDialog()">Create New Category</button>
      </div>
    </div>
  </ng-template>
</ng-container>

<ng-template #loadingOrError>
  <anon-loading-or-error [error]="error"></anon-loading-or-error>
</ng-template>
